import * as React from 'react';
import FirestoreContext, { FirestoreContextType } from './FirestoreContext';

type Props = {
  firebase: firebase.app.App;
  children: React.ReactNode;
};

type State = FirestoreContextType;

class FirestoreProvider extends React.Component<Props, State> {
  state: State = {
    // eslint-disable-next-line react/no-unused-state, react/destructuring-assignment
    firestore: this.props.firebase.firestore(),
  };

  render() {
    const { children } = this.props;
    return <FirestoreContext.Provider value={this.state}>{children}</FirestoreContext.Provider>;
  }
}

export default FirestoreProvider;
